export default __webpack_public_path__ + "static/media/InsideBlood_03.4093fcba.png";